import { Portfolio, Investor } from './model.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { RemoteService } from 'app/services/remote.service';
import { LocalStorageService } from 'ngx-store';
@Injectable({
  providedIn: 'root'
})
export class ShareService {
  portfolio = new Portfolio();

  investor = new Investor();

  rebalanceDone = false;

  public user = new Subject<object>();

  private messageSource = new BehaviorSubject(this.portfolio);
  currentPortfolio = this.messageSource.asObservable();

  private remaingMoney = new BehaviorSubject(0);
  getRemaingMoney = this.remaingMoney.asObservable();

  private investorsrc = new BehaviorSubject(this.investor);
  currentInvesor = this.investorsrc.asObservable();


  private rebalancesrc = new BehaviorSubject(this.rebalanceDone);
  currentRebalanceStatus = this.rebalancesrc.asObservable();
  stockList = [];

  constructor(private service: RemoteService,
    private ls: LocalStorageService) { }

  setRebalanceStatus(rebalanceDone: boolean) {
    this.rebalancesrc.next(rebalanceDone);
  }

  selectedInvestor(investor: Investor) {
    this.investorsrc.next(investor);
  }

  selectedPortFolio(portfolio: Portfolio) {
    this.messageSource.next(portfolio);
  }
  getRemainingCash(value) {
    this.stockList = [];
    if (value.stocks.length > 0) {
      value.stocks.forEach(async element => {
        const payload = {
          stockId: element.stockId,
          isSplitReqiured: true
        }
        await this.service.getTradesList(payload).subscribe(resStcok => {
          this.stockList.push({ stockList: resStcok, stockId: element.stockId });
          if (this.stockList.length == value.stocks.length) {
            var openinBalanceTotal = 0;
            this.stockList.map((res, index5) => {
              const dateSorting = res.stockList.sort((a, b) => {
                return +new Date(a.tradeDate) - +new Date(b.tradeDate);
              });
              dateSorting.map((element, index) => {
                if (element.tradeType === "OPENING_BALANCE") {
                  if (element.baseCurrency !== element.stockCurrency) {
                    if (element.stockCurrency === element.tradeCurrency) {
                      openinBalanceTotal += element.quantity * element.price / element.exchangeRate;
                    } else {
                      openinBalanceTotal += element.quantity * element.price * element.exchangeRate;
                    }
                  } else {
                    openinBalanceTotal += element.quantity * element.price;
                  }
                }
              })
              if (index5 + 1 == this.stockList.length) {
                this.ls.set('OpeninBalance', openinBalanceTotal);
              }
            })
          }
        }, (error) => {
          // this.service.errorFunction(error);
        })
      });
    } else {
      this.ls.set('portfolioRemainingCash', value.allocatedCash);
    }
  }

  User(val) {
    this.user.next(val);
  }
}
